import { filter, head, map, over, pipe, prop, propOr, take, takeRight, uniq } from 'lodash/fp'
import Moment from 'moment'
import * as Redux from 'redux'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as Constants from './constants'

const selectSessionAggs = Elasticsearch.createAggSelector('sessions')
const selectSessions = pipe(
  selectSessionAggs,
  map(Elasticsearch.selectKey),
  map((sessionId: string) => ({sessionId})),
)

const selectTimeStamp = prop('timestamp')
const selectSessionId = prop('sessionId')
const selectAction = propOr({}, 'action')
const selectValue = propOr({}, 'value')
const selectActionValue = pipe(selectAction, selectValue)
const selectEmail = pipe(selectActionValue, prop('email'))
const selectInvite = pipe(selectActionValue, prop('inviteToken'))
const selectType = pipe(selectAction, prop('type'))
const ofType = (filterType: string) => pipe(
  selectType,
  (actionType) => actionType === filterType,
)
const selectSessionEvents = propOr([], 'results')
const reduceEvents = (selector: any) => pipe(map(selector), filter(Boolean), uniq)
const reduceSingleEvent = (selector: any) => pipe(reduceEvents(selector), head)
const bottomLine = pipe(
  selectSessionEvents,
  over([
    reduceSingleEvent(selectEmail),
    reduceSingleEvent(selectInvite),
    reduceSingleEvent(ofType('SUBMIT_SIGNUP_REQUEST')),
    pipe(map(selectTimeStamp), over([take(1), takeRight(1)]), map(head)),
    reduceSingleEvent(selectSessionId),
  ]),
  ([email, inviteToken, signup, timeStamps, sessionId]) =>
    ({
      email,
      inviteToken,
      sessionEnd: timeStamps[1],
      sessionId,
      sessionStart: timeStamps[0],
      signup,
    }),
)
const selectSessionIdFromResponse = pipe(
  selectSessionEvents,
  reduceSingleEvent(selectSessionId),
)

const initialViewState = {isLoading: false}
const viewReducer: Redux.Reducer<{isLoading: boolean}> = (state = initialViewState, action) => {
  switch (action.type) {
    case Constants.FetchOnboardingSession.request:
    case Constants.FetchOnboardingSessions.request:
      return {
        isLoading: true,
      }
    case Constants.FetchOnboardingSession.success:
    case Constants.FetchOnboardingSession.error:
    case Constants.FetchOnboardingSessions.success:
    case Constants.FetchOnboardingSessions.error:
      return {
        isLoading: false,
      }
    default:
      return state
  }
}

const sessionReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case Constants.FetchOnboardingSession.success:
      return [
        ...state,
        bottomLine(action.payload.response),
      ]
    default:
      return state
  }
}

const sessionsRawReducer = (state = {}, action: any) => {
  switch (action.type) {
    case Constants.FetchOnboardingSession.success:
      const sessionId = selectSessionIdFromResponse(action.payload.response)
      return {
        ...state,
        [sessionId as any]: selectSessionEvents(action.payload.response),
      }
    default:
      return state
  }
}

const sessionsReducer = (state: any[] = [], action: any) => {
  switch (action.type) {
    case Constants.FetchOnboardingSessions.success:
      return selectSessions(action.payload.response)
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  form: Form.createReducer(
    Constants.REPORTS_ONBOARDING_SESSIONS,
    {
      sessionId: '',
      timeWindowEnd: Moment().utc().format(),
      timeWindowStart: Moment().subtract(1, 'day').utc().format(),
    },
  ),
  session: sessionReducer,
  sessions: sessionsReducer,
  sessionsRaw: sessionsRawReducer,
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/reports/onboarding-sessions/reducer.ts